<template>
	<div class="container has-text-centered" v-if="inited">
		<component :is="currentComponent" v-bind="propsToPass"/>
	</div>
</template>
<script lang="ts">
import { STATE_MODULES } from '@/store/state-modules';
import { defineComponent, PropType } from 'vue'
import { LeadsActions } from '@/store/modules/leads/actions';
import { LeadsGetters } from '@/store/modules/leads/getters';
import { mapGetters } from 'vuex';
import { LeadsMutations } from '@/store/modules/leads/mutations';
import { GoogleMapsMixin } from '@/utils/mixins';
import PlansWrapper from '../leads/topup/PlansWrapper.vue';
import Payment from '../leads/topup/Payment.vue';
import ThankYou from '../leads/topup/ThankYou.vue';
import leadsConstants, { STEP_COMP_NAMES } from '../../constants/leads';

export default defineComponent({
	mixins: [GoogleMapsMixin],
	props: {
		plansToShow: {
			type: Array as PropType<number[]>,
			default: () => leadsConstants.LEADS_PLANS_TO_SHOW.DEFAULT
		}
	},
	computed: { 
		...mapGetters(STATE_MODULES.LEADS, {
			inited: LeadsGetters.PLANS_INITED,
			currentComponent: LeadsGetters.CURRENT_COMPONENT
		}),
		propsToPass () {
			if (this.currentComponent === STEP_COMP_NAMES.PLANS_WRAPPER) {
				return { plansToShow: this.plansToShow };
			}
			return {};
		}
	},
	unmounted () {
		this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.RESET_LEADS_STATE}`)
	},
	methods: {
		onGoogleLoaded (): void {
			if (!this.inited) { 
				this.$store.dispatch(`${STATE_MODULES.LEADS}/${LeadsActions.INIT_LEAD_PLANS}`);
			}
		}
	},
	components: {
		PlansWrapper,
		Payment,
		ThankYou
	},
	watch: {
		currentComponent () {
			this.$emit("scroll-to-top");
		}
	}
})
</script>

<style scoped>
@media (max-width: 1024px) {
	.container {
		max-width: 700px !important;
	}

	.button {
		max-width: 300px;
	}
}
</style>
